<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Stripe Ids</h3>
      <div v-if="isLoading">
        <div class="tw-mt-3 tw-text-gray-500 tw-text-xs tw-font-normal">Stripe Subscription ID</div>
        <base-skeleton-loader class="tw-h-3 tw-w-48 tw-mt-2 tw-mb-1.5" />
        <div class="tw-mt-3 tw-text-gray-500 tw-text-xs tw-font-normal">Stripe Customer ID</div>
        <base-skeleton-loader class="tw-h-3 tw-w-36 tw-mt-2 tw-mb-1.5" />
      </div>
      <div v-else>
        <base-field class="tw-mt-3" title="Stripe Subscription ID" :value="subscription.stripeSubscriptionId"></base-field>
        <base-field class="tw-mt-3" title="Stripe Customer ID" :value="subscription.stripeCustomerId"></base-field>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Close
        </base-button>
      </div>
      <inline-error id="stripe-ids-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>
<script>
import InlineError from "@/components/InlineError";

export default {
  name: "StripeIdsModal",
  components: { InlineError },
  props: {
    businessId: String,
    userId: String,
    userBusinessPlanId: String,
  },
  data() {
    return {
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
      subscription: {},
    };
  },
  methods: {
    show() {
      this.isLoading = true;
      this.$axios
        .get(`/businesses/${this.businessId}/members/${this.userId}/memberplans/${this.userBusinessPlanId}/subscription`)
        .then((res) => {
          this.subscription = res.data;
        })
        .catch((err) => {
          this.errorTitle = `Sorry, we could not retrieve the Stripe Ids`;
          this.errorMessage = `We were not able to retrieve the Stripe Ids. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
      this.$refs.modal.show();
    },
    hide() {
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
      this.subscription = {};
      this.$refs.modal.hide();
    },
  },
};
</script>
